import { Radio, Checkbox, Select, Input, Space } from "antd";
import { Question } from "../../../../hooks/api/survey";

export function QuestionPreview({ question }: { question: Question }) {
  return (
    <>
      {/* <strong style={{ marginRight: 10 }}>
        {question.title || "Untitled question"}
      </strong> */}

      {question.type === "radio" && (
        <Radio.Group style={{ display: "flex", flexDirection: "column" }}>
          {question.options?.map((o) => (
            <Radio key={o.value} value={o.value}>
              {o.label}
            </Radio>
          ))}
        </Radio.Group>
      )}

      {question.type === "checkbox" && (
        <Space direction="vertical">
          {question.options?.map((o) => (
            <Checkbox key={o.value}>{o.label}</Checkbox>
          ))}
        </Space>
      )}

      {question.type === "select" && (
        <Select
          style={{ width: 200 }}
          options={question.options?.map((o) => ({
            label: o.label,
            value: o.value,
          }))}
        />
      )}

      {question.type === "text" && <Input disabled />}

      {question.type === "number" && <Input type="number" disabled />}
    </>
  );
}
